import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentHead } from '../../../lib/components';
import { ContentBox } from '../../../lib/components/compound/pages/contentBox';
import { NewTaskButton } from '../shared/newTaskButton';
import { TaskType } from '../shared/types';
import { TableProps } from './tables/columns';
import { ExportsTable } from './tables/export';
import { ImportsTable } from './tables/import';

const table: Record<TaskType, FC<TableProps>> = {
  export: ExportsTable,
  import: ImportsTable
};

interface TaskContentBoxProps {
  type: TaskType;
  tableProps?: TableProps;
  paddingTop?: string;
  paddingBottom?: string;
  paddingLeft?: string;
  paddingRight?: string;
}

export const TaskContentBox: FC<TaskContentBoxProps> = ({ type, tableProps, ...props }) => {
  const { t } = useTranslation();
  const TableComponent = table[type];

  const padding = {
    paddingTop: props.paddingTop,
    paddingBottom: props.paddingBottom,
    paddingLeft: props.paddingLeft,
    paddingRight: props.paddingRight
  };

  const renderActions = () => {
    return (
      <Box display="flex" gap=".5rem">
        <NewTaskButton type={type} variant={'contained'} />
      </Box>
    );
  };

  return (
    <ContentBox
      headComponent={
        <ContentHead
          headline={t('tasks:TITLE', { context: type, count: 2 })}
          showActions
          renderActions={renderActions}
        />
      }
      {...padding}
    >
      <TableComponent {...tableProps} />
    </ContentBox>
  );
};
